import { BrowserRouter, Route, Routes } from "react-router-dom";
import { UserProvider } from "../context/UserContext";
import ScrollToTop from "../utils/ScrollToTop";

// Pages
import CartPage from "../pages/cart/CartPage";
import HomePage from "../pages/home/HomePage";
import LoginPage from "../pages/login/LoginPage";
import OrderPage from "../pages/order/OrderPage";
import ProductPage from "../pages/product/ProductPage";
import SearchResultsPage from "../pages/search/SearchResultsPage";

// Admin
import CategoriesPage from "../pages/admin/category/CategoriesPage";
import AdminDashboardPage from "../pages/admin/dashboard/AdminDashboardPage";
import OrderDetails from "../pages/admin/orders/OrderDetailsPage";
import OrdersPage from "../pages/admin/orders/OrdersPage";
import AddProductsPage from "../pages/admin/products/AddProductsPage";
import ProductsPage from "../pages/admin/products/ProductsPage";

import OrdersDetailsPage from "../pages/admin/orders/OrderDetailsPage";
import EditProductsPage from "../pages/admin/products/EditProductsPage";
import AdminOutlet from "./AdminOutlet";

function Router() {
  return (
    <UserProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products/flag/:flag" element={<SearchResultsPage />} />
          <Route path="/products/:category" element={<SearchResultsPage />} />
          <Route path="/products" element={<SearchResultsPage />} />
          <Route path="/product/:productId" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route element={<AdminOutlet />}>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/products" element={<ProductsPage />} />
            <Route
              path="/admin/products/:productId"
              element={<EditProductsPage />}
            />
            <Route path="/admin/add-product" element={<AddProductsPage />} />
            <Route path="/admin/orders" element={<OrdersPage />} />
            <Route path="/admin/order/:id" element={<OrdersDetailsPage />} />
            <Route path="/admin/categories" element={<CategoriesPage />} />
            <Route
              path="/admin/categories/details"
              element={<OrderDetails />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default Router;
